import React from "react";
import { useUserStore } from "../../../state/useUserStore";

interface TableProps {
  columns: string[];
  data: any[][];
}

const MobilePreviewTable: React.FC<TableProps> = ({ columns, data }) => {
  const { user } = useUserStore();
  if (!data) {
    // Handle the case where data is undefined, if needed
    return null;
  }
  return (
    <div>
      {/* Mobile */}
      <div className="relative ">
        <table className="w-full text-[6.34px] text-left text-black dark:text-black md:hidden lg:hidden">
          <thead
            className="text-[6.34px] text-white sentencecase "
            style={{ backgroundColor: user.brandColor || "#044e97" }}
          >
            <tr>
              {columns.map((column, index) => (
                <th
                  key={index}
                  scope="col"
                  className="pl-[1em] py-3 text-[6.34px]"
                >
                  {column}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((row, rowIndex) => (
              <tr
                key={rowIndex}
                className={`${
                  rowIndex % 2 === 0 ? "bg-white" : "bg-white dark:bg-gray-800"
                } border-b dark:border-gray-700`}
              >
                {row.map((cell, cellIndex) => (
                  <td
                    key={cellIndex}
                    className={`pl-[1em] py-4 ${
                      cellIndex === 0
                        ? "font-medium text-black text-[6.34px]"
                        : ""
                    } whitespace-nowrap dark:text-white`}
                  >
                    {cell}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default MobilePreviewTable;
